
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { PromiserMixin, PromiserType } from 'vuex-modals';
import PersistentModal from '@/components/shared/modals/PersistentModal';
import { Tag } from '@/api/interfaces';
import { tagCreateData } from '@/api/core/tag';
import { repositories } from '@/api/ApiFactory';
import ErrorHandler from '@/components/shared/errorHandler';
import { ValidationProvider } from 'vee-validate';


@Component
export default class AddOrEditTagModal extends Mixins<
  PromiserType,
  PersistentModal
>(PromiserMixin, PersistentModal) {
  @Prop({ default: null }) private data!: Tag | null;

  public $refs!: {
    obs: InstanceType<typeof ValidationProvider>;
  };

  private loading = {
    submit: false,
  };

  private tag: tagCreateData = {
    name: '',
    slug: null,
    description: '',
    color: '',
  };

  created() {
    if (this.data != null) {
      this.tag = {
        name: this.data.name,
        slug: this.data.slug,
        description: this.data.description,
        color: this.data.color,
      };
    }
  }

  mounted() {
    if (this.data) {
      this.$nextTick(() => {
        this.$refs.obs.validate();
      });
    }
  }

  private async submitUpdate() {
    this.loading.submit = true;
    try {
      const { data } = await repositories.core.tag.update(
        this.data!.slug!,
        this.tag,
      );
      this.ok(data);
    } catch (error) {
      this.$toasted.error(new ErrorHandler({ error, status: true }).toString());
    }
    this.loading.submit = false;
  }

  private async submitCreate() {
    this.loading.submit = true;
    try {
      const { data } = await repositories.core.tag.create(
        this.tag,
      );
      this.ok(data);
    } catch (error) {
      this.$toasted.error(new ErrorHandler({ error, status: true }).toString());
    }
    this.loading.submit = false;
  }

  private submit() {
    return this.data != null ? this.submitUpdate() : this.submitCreate();
  }
}
